
  import React from "react"
  import Component from "/Users/samdozor/Documents/jenny/jmarzphoto/src/layouts/index.js"
  import data from "/Users/samdozor/Documents/jenny/jmarzphoto/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js